/** Display labels for internal vs sponsor/CRO users (API still uses IsCRO 0/1). */
export const USER_TYPE_INTERNAL_LABEL = "Internal";
export const USER_TYPE_SPONSOR_CRO_LABEL = "Sponsor/CRO";

/** @param {boolean|number|string|null|undefined} value */
export function isSponsorCroUserRecord(value) {
  if (value === true || value === 1 || value === 2 || value === "1" || value === "2")
    return true;
  const normalized = String(value ?? "").trim().toLowerCase();
  return (
    normalized === "external" ||
    normalized === "sponsor/cro" ||
    normalized === "sponsor" ||
    normalized === "cro"
  );
}

/** @param {boolean|number|string|null|undefined} isCro */
export function formatUserTypeLabel(isCro) {
  return isSponsorCroUserRecord(isCro)
    ? USER_TYPE_SPONSOR_CRO_LABEL
    : USER_TYPE_INTERNAL_LABEL;
}

/** Session user is Sponsor/CRO (`IsCRO` 1 or 2). Internal staff is unchanged. */
export function isSponsorCroSession(userData) {
  if (!userData) return false;
  return isSponsorCroUserRecord(
    userData.IsCRO ?? userData.IsCro ?? userData.isCRO,
  );
}

/** Reserved Sponsor / CRO role names — only these two are offered for Sponsor/CRO users. */
export function isSponsorOrCroRoleLabel(roleLabel) {
  const n = String(roleLabel ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
  return (
    n === "sponsor" ||
    n === "cro" ||
    n === "sponsor/cro" ||
    n === "sponsor cro"
  );
}
